/* eslint-disable eqeqeq */
import { Popover } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { RENTAL_STATUS } from "../constant";

const LabelAndValue = ({ label = "", value = "", border = false }) => {
  return (
    <div
      className={`py-4 ${border ? "border-y-[0.5px] border-light-grey" : ""}`}
    >
      <p className="font-poppins font-medium text-xs">{label}</p>
      <div className="mt-2 flex items-center">
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            fill="none"
            viewBox="0 0 16 17"
          >
            <path stroke="#DFDFDF" d="M1 0v7a4 4 0 004 4h11" />
          </svg>
        </span>

        <p className="ml-2 font-aileron font-semibold text-sm text-grey-200">
          {value}
        </p>
      </div>
    </div>
  );
};

const ReceivedBy = () => {
  const { currentRental } = useSelector((state) => state.rentals);

  const [open, setOpen] = useState(false);

  return (
    <Popover
      open={open}
      placement="bottomRight"
      trigger="click"
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div className="w-[460px] bg-background-white rounded-xl p-6 shadow-moreFilters">
          <div className="flex justify-between">
            <p className="text-base font-medium text-black font-poppins">
              Digital Signature
            </p>

            <button type="button" onClick={() => setOpen(false)}>
              <CloseIcon className="w-6 h-6 stroke-dark-gray" />
            </button>
          </div>

          <div className="mt-4">
            <LabelAndValue
              label="Received by"
              value={currentRental?.metaData?.receiverName || "--"}
            />

            <LabelAndValue
              border
              label="Feedback"
              value={currentRental?.metaData?.feedback || "--"}
            />

            <p className="mt-4 font-poppins font-medium text-xs">Signature</p>
            <div className="mt-2 pt-24 h-[111px] bg-white flex items-center justify-center rounded-lg overflow-hidden">
              {currentRental?.status == RENTAL_STATUS.COMPLETED && (
                <img
                  src={currentRental?.metaData?.signature}
                  className="w-[100px] h-[60px] object-contain scale-x-[3] scale-y-[2.5]"
                  alt="digital-signature"
                />
              )}
            </div>
          </div>
        </div>
      }
    >
      <div className="flex flex-col items-start gap-y-2 w-[137px]">
        <p className="font-aileron font-normal text-10 text-dark-gray capitalize">
          Received By
        </p>

        <div
          role={currentRental?.status == RENTAL_STATUS ? "button" : ""}
          className="flex items-center gap-x-2"
          onClick={() => {
            if (currentRental?.status == RENTAL_STATUS.COMPLETED) setOpen(true);
          }}
        >
          <p className="font-aileron font-semibold text-xs text-black capitalize whitespace-nowrap">
            {currentRental?.metaData?.receiverName || "--"}
          </p>

          {currentRental?.status == RENTAL_STATUS.COMPLETED && (
            <ChevronIcon className="w-4 h-4 stroke-dark-gray" />
          )}
        </div>
      </div>
    </Popover>
  );
};

export default ReceivedBy;
